import { render, staticRenderFns } from "./PortalHome.vue?vue&type=template&id=6cbeb58a&scoped=true&"
import script from "./PortalHome.vue?vue&type=script&lang=js&"
export * from "./PortalHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbeb58a",
  null
  
)

export default component.exports